import { Organization }                 from '@app/modules/organization/models/organization.model';
import { RequestState }                 from '@core/interfaces/api.interface';
import { IStructureExportEntityEvents } from '@core/interfaces/entity.interface';

// ENUMS #############################################################
// API enums *********************************************************
export enum ExportFileTypeEnum {
	CSV = 'csv',
	JSON = 'json'
}

export enum ExportSetTypeEnum {
	BUSINESS_PREMISES = 'business-premises',
	ORGANIZATION = 'organization',
	TENANT = 'tenant',
}

export enum ExportSetStatusEnum {
	EXPORTING = 'exporting',
	FAILED = 'failed',
	SUBMITTED = 'submitted',
	SUCCESS = 'success',
}

export enum ExportSetModeEnum {
	ERS_DATA = 'ersData',
	FCC_DATA = 'fccData',
	FCC_OPEN_TRANSACTIONS = 'openTransactions',
	FCC_VERSIONS = 'fccVersions',
	FULL = 'full',
	VALIDATION_REPORT = 'validationReport'
}

// UI enums *********************************************************


// INTERFACES ########################################################
// API interfaces ****************************************************
export interface IExportSetFailure {
	code: string;

	identifier: string;

	message: string;

	type: string;
}

export interface IExportSetOptions {

	fileType?: ExportFileTypeEnum;

	exportMode: ExportSetModeEnum;

	includeDisabledErs?: boolean;

	name?: string;
}

export interface IExportFile {
	organizationList?: Array<Organization>;
}

// UI interfaces *****************************************************


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ExportSetTMO {

	public id: string = undefined;

	public tenantId: string = undefined;

	public name?: string = undefined;

	public filename: string = undefined;

	public status: ExportSetStatusEnum = undefined;

	public exportOptions: IExportSetOptions = undefined;

	public exportType: ExportSetTypeEnum = undefined;

	public exportObjectId: string = undefined;

	public createdBy: string = undefined;

	public createdDate: Date = undefined;

	public exportStartDate: Date = undefined;

	public exportFinishDate: Date = undefined;

	public failures: Array<IExportSetFailure> = undefined;
}


// MODEL USED IN APPLICATION (with additional properties)
export class ExportSet extends ExportSetTMO {

	public etag?: string = undefined;

	public ui?: IStructureExportEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		exportObjectEntityName: undefined
	};
}
